<template>
    <ShadowBoxContainer>
        <ListContainer
            :image="require(`@/assets/img/icon_listmytools_handoff.svg`)"
            imageLabel="Handoff Method"
            heading="How would you like to handle delivery?"
            :step="6"
        >
            <div class="ph3 ph4-ns pb4">
                
                <!-- renter pick-up -->
                <DeliveryOption
                    @change="renterToggle = $event.value"  
                    class="mb3" 
                    title="Allow renters to pick up and return"
                    infoDescription="Renters will be given the address designated by you to pick up and return the tools
                    and equipment. We recommend allowing Tooliaba delivery services if you think that your tool or equipment
                    won't fir in most cars or trucks."
                     
                />
                <!-- owner delivery -->
                <!-- This section should be refactored into a component at some point. -->
                <div class="pb3 ba b--light-gray">
                    <div class="ph3">
                        <div class="flex flex-wrap justify-between items-center">
                            <div class="mt3 flex items-center">
                                <h6>Offer your own delivery services</h6>
                                <img @click="showInfo = true" class=" ml2 pointer" src="@/assets/img/icon_info.svg"/>
                            </div>
                            <Toggle class="mt3" @change="toggleOwnerDelivery($event)"/>
                        </div>
                        <OwnerDelivery class="mt3" v-if="ownerToggle" v-model="deliveryPrice"/>
                    </div>
                </div>
                <OverlayWarning :showWarning="showInfo">
                    <InfoOverlay
                        title="Offer your own delivery services"
                        description="offer service etc."
                        @cancel="showInfo = false"
                    />
                </OverlayWarning>

                
                <!-- tooliaba delivery -->
                <DeliveryOption
                    @change="tooliabaToggle = $event.value"  
                    class="mt3" 
                    title="Allow Tooliaba delivery services"
                    infoDescription="Tooliaba delivery services is the most reliable way to ensure that your tools and equipment are 
                    delivered and returned safely and on time"
                />

            </div>

        </ListContainer>
        <!-- buttons -->
        <template slot="actionBar">
            <NavigationButtons :enabledForward="isEnabled" back="Back" forward="Next" @backClick="$router.push('/tags')" @forwardClick="next" />
        </template>

    </ShadowBoxContainer>
</template>

<script>
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import ListContainer from '@/components/list/shared/ListContainer.vue';
import Toggle from '@/components/controls/Toggle.vue';
import OwnerDelivery from '@/components/list/deliveryOptions/OwnerDelivery.vue';
import DeliveryOption from '@/components/list/deliveryOptions/DeliveryOption.vue';
import OverlayWarning from '@/components/global/OverlayWarning.vue';
import InfoOverlay from '@/components/global/InfoOverlay.vue';
import { mapMutations } from 'vuex';

export default {
    components: {
        NavigationButtons,
        ShadowBoxContainer,
        ListContainer,
        Toggle,
        OwnerDelivery,
        DeliveryOption,
        OverlayWarning,
        InfoOverlay
    },
    data() {
        return {
            showInfo: false,
            deliveryPrice: 0,
            renterToggle: false,
            ownerToggle: false,
            tooliabaToggle: false,
            deliveryOptions: []
        };
    },
    methods: {
        ...mapMutations('newListing', [
            'setDeliveryPrice',
            'setDeliveryOptions'
        ]),
        toggleOwnerDelivery(event) {
            if (event.value === true) {
                this.ownerToggle = true;
            } else {
                this.ownerToggle = false;
                this.deliveryPrice = 0;
            }
        },
        next() {
            this.setDeliveryPrice(this.deliveryPrice);
            this.setDeliveryOptions({
                renterPickup: this.renterToggle,
                ownerDelivery: this.ownerToggle,
                tooliabaDelivery: this.tooliabaToggle
            });

            var route = '/rates';

            if (this.renterToggle === true || this.tooliabaToggle === true) {
                route = '/pickup-address';
            }

            this.$router.push(route);
        }
    },
    computed: {
        isEnabled() {
            var enabled = true;

            if (
                this.renterToggle === false &&
                this.ownerToggle === false &&
                this.tooliabaToggle === false
            ) {
                enabled = false;
            }

            if (this.ownerToggle === true && this.deliveryPrice === 0) {
                enabled = false;
            }

            return enabled;
        }
    }
};
</script>
